import { render } from "./CustomerProfileShow.vue?vue&type=template&id=81cceaf6&scoped=true"
import script from "./CustomerProfileShow.vue?vue&type=script&lang=js"
export * from "./CustomerProfileShow.vue?vue&type=script&lang=js"

import "./CustomerProfileShow.vue?vue&type=style&index=0&id=81cceaf6&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81cceaf6"]])

export default __exports__